export default __webpack_public_path__ + "static/4-de8083aa077b063d291ef84ff5a14890.gif";